import * as v from 'valibot';
import { valuesEquivalent } from '../valibot';

const passwordRegExp =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,64}$/;

/**
 * Factory function that creates a password reset form schema with dynamic min length
 * @param passwordMinLength Minimum password length (default: 8)
 */
const resetPasswordFormSchema = (passwordMinLength: number = 8) =>
  v.pipe(
    v.object({
      password: v.pipe(
        v.string('Required'),
        v.nonEmpty('Required'),
        v.minLength(passwordMinLength, `Password must be at least ${passwordMinLength} characters`),
        v.maxLength(64, 'Password must not exceed 64 characters'),
        v.regex(
          passwordRegExp,
          'Password must contain 1 upper case letter, 1 lower case letter, 1 number, and 1 special character'
        )
      ),
      passwordConfirmation: v.pipe(v.string('Required'), v.nonEmpty('Required')),
    }),
    valuesEquivalent('password', 'passwordConfirmation', 'Passwords must match')
  );

export default resetPasswordFormSchema;
